export default "__VITE_ASSET__DV5Mcx7K__"